import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage'

const config = {
    apiKey: "AIzaSyCgK_CM0yI2THq-PFNZsMBabNjtmvRfsPE",
    authDomain: "hypercube-28-website.firebaseapp.com",
    databaseURL: "https://hypercube-28-website.firebaseio.com",
    projectId: "hypercube-28-website",
    storageBucket: "hypercube-28-website.appspot.com",
    messagingSenderId: "428307248677"
};

firebase.initializeApp(config);

const auth = firebase.auth;
const firestore = firebase.firestore();
const storage = firebase.storage;

export {
    storage,
    auth,
    firestore,
}
